import { useState } from 'react';

import { SharedComponentRefModel } from '../../Models/SharedComponentRefModel';
import GenericPropertyInput from './GenericPropertyInput';
import GenericPropertyInputRefContent from './GenericPropertyInputRefContent';
import { SharedComponentInputDialog } from './SharedComponentInputDialog';

type SharedComponentInputProps = {
	sharedComponentRef: SharedComponentRefModel | undefined;
	onSharedComponentRefChange: (sharedComponentRef: SharedComponentRefModel | undefined) => void;
	isEditable?: boolean;
};

export default function SharedComponentInput({ sharedComponentRef, onSharedComponentRefChange, isEditable = true }: SharedComponentInputProps) {
	const [open, setOpen] = useState(false);

	// In non-edit mode, just show the reference name
	if (!isEditable) {
		return <GenericPropertyInputRefContent value={sharedComponentRef} />;
	}

	return (
		<GenericPropertyInput value={sharedComponentRef} onValueChange={onSharedComponentRefChange} onOpen={() => setOpen(true)}>
			<GenericPropertyInputRefContent value={sharedComponentRef} />
			{open && (
				<SharedComponentInputDialog
					open={open}
					setOpen={setOpen}
					sharedComponentRef={sharedComponentRef}
					onSharedComponentRefChange={onSharedComponentRefChange}
				/>
			)}
		</GenericPropertyInput>
	);
}
